import { KTCard } from '../../../_dashboard/helpers'
import LegalManagement from './LegalManagement'

const LegalListWrapper = () => (
  <KTCard>
    <LegalManagement />
  </KTCard>
)

export { LegalListWrapper }
